export const members_global = [
  {
    id: 1,
    name: "Phạm Xuân Duy",
    email: "xduy.pham@gmail.com",
    user_name: "duy_px",
    phone_number: "0865675232",
    avatar: "https://avatars2.githubusercontent.com/u/31473225?s=460&v=4"
  },
  {
    id: 2,
    name: "Jason Oner",
    email: "Jason.oner@gmail.com",
    user_name: "Jason_oner",
    phone_number: "0123456789",
    avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg"
  },
  {
    id: 3,
    name: "Travis Howard",
    email: "travis.howard@gmail.com",
    user_name: "travis_howard",
    phone_number: "0988225588",
    avatar: "https://cdn.vuetifyjs.com/images/lists/2.jpg"
  },
  {
    id: 4,
    name: "Ali Connors",
    email: "ali.connors@gmail.com",
    user_name: "ali_connors",
    phone_number: "0741589632",
    avatar: "https://cdn.vuetifyjs.com/images/lists/3.jpg"
  },
  {
    id: 5,
    name: "Cindy Baker",
    email: "Cindy.Baker@gmail.com",
    user_name: "cindy_baker",
    phone_number: "0856532587",
    avatar: "https://cdn.vuetifyjs.com/images/lists/4.jpg"
  },
  {
    id: 6,
    name: "Join mayer",
    email: "Join.mayerr@gmail.com",
    user_name: "Join_mayer",
    phone_number: "0123456874",
    avatar: "https://cdn.vuetifyjs.com/images/lists/5.jpg"
  }
];
